import React from 'react';
import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import styles from 'custom/style.module.css';
import flightMainStyles from './flightreport.module.css';
import { CloseIconBtn } from 'custom/constants';
import DownloadIcon from '@mui/icons-material/Download';
import FlightReportContainer from '../flights/tabs/flightreport/FlightReportContainer';
import Download from '../flights/downloadreport/Report';
import moment from 'moment';

const FlightReportPDFDownload = (props) => {
  return (
    <div>
      <Dialog
        open={props.pdfModal}
        onClose={props.onClose}
        aria-labelledby='Flight Report'
        aria-describedby='Flight Report'
        maxWidth='md'
        fullWidth={true}
      >
        <DialogTitle className={styles.fSpaceBtw} sx={{ borderBottom: '1px solid #f0f0f0' }}>
          <Typography variant='h6' component={'div'} color={'primary'}>Download Flight Report</Typography>
          <CloseIconBtn onClick={props.onClose} />
        </DialogTitle>

        <Box sx={{
          height: '0px',
          visibility: 'hidden',
          overflow: 'hidden',
        }}>
          <FlightReportContainer showReportModal={props.showReportModal}
            printFunction={props.printFunction}
            exclude_disc={props.exclude_disc}
            updatedisableFlightFields={props.updatedisableFlightFields}
            disableFlightFields={props.disableFlightFields}
          />

        </Box>

        <DialogContent>
          <div className={flightMainStyles.downloadWrapper}>
            <DownloadIcon className={flightMainStyles.downloadIcon} />
            <DialogContentText fontSize={'0.9rem'} textAlign={'center'}>
              Generating Report for download. Please wait...
            </DialogContentText>
            <div className={flightMainStyles.downloadBtnWrapper}>
              <Download
                flightReportDetails={props.flightReportDetails}
                flightInfo={props.flightInfo}
                note={props.note}
                discrepancy={props.discrepancy}
                products={props.products}
                manifest={props.manifest}
                history={props.history}
                statistics={props.statistics}
                flightReport={props.flightReport}
                manifestSummary={props.manifestSummary}
                flightReportSummary={props.flightReportSummary}
                discrepancySummary={props.discrepancySummary}
                flight_gate={props.flight_gate}
                nil={props.nil}
                filename={`Flight Report - ${props.flightInfo?.airline?.code}${props.flightInfo?.flight_no}/${moment(props.flightInfo?.flight_date).format('DDMMMYY').toUpperCase()}`}
                title='Download'
                ctype={props.ctype}
                exclude_disc={props.exclude_disc}
                airlineLogo={props.airlineLogo}
                rowSelectionIds={props.rowSelectionIds}
              />
            </div>
          </div>
        </DialogContent>

      </Dialog>
    </div>
  );
};
export default FlightReportPDFDownload;